// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Wq-z","imageAndVideoCount":"Xq-z","imageAndVideoContainer":"Yq-z","viewAllReviews":"Zq-z"};